module.exports = __webpack_public_path__ + "fonts/ralewaylight.f8141a2.woff";